<template>
  <Forms ref="frmGroup"
         title="Pasta"
         :showClearButton="false"
         :showSearchButton="false"
         :showTipFooter="false"
         :showReload="false"
         :showSaveButton="true"
         :showBackButton="true"
         :disabledKeyUpEnter="true"
         v-on:Back="onBack"
         v-on:Save="onSave">

    <div class="form-group row">
      <div class="col-md-12 mb-3">
        <label for="txtNome">{{$lang.Documents.LabelName}}:</label>
        <div class="input-group">
          <b-form-input type="text"
                        name="txtNome"
                        ref="nomeComp"
                        :placeholder="$lang.Documents.PlaceholderName"
                        :autofocus="true"
                        v-model="form.nome.value"
                        :maxlength="form.nome.maxlength"
                        :required="form.nome.required"
                        :state="form.nome.state" />
        </div>
      </div>
      <div class="col-md-4 mb-3">
        <label for="#">{{$lang.Documents.LabelType}}:</label>
        <div class="input-group">
          <b-form-select v-model="form.gedTipoID.value"
                         :options="form.gedTipoID.options"
                         :state="form.gedTipoID.state"
                         :disabled="false"
                         class="mb-3"
                         name="cbxGedTipo">
            <template slot="first">
              <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
            </template>
          </b-form-select>
        </div>
      </div>

      <div class="col-md-4">
        <label for="#">{{$lang.Documents.LabelSubject}}:</label>
        <div class="input-group">
          <b-form-select v-model="form.gedAssuntoID.value"
                         :options="form.gedAssuntoID.options"
                         :state="form.gedAssuntoID.state"
                         :disabled="false"
                         class="mb-3"
                         name="cbxGedAssunto">
            <template slot="first">
              <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
            </template>
          </b-form-select>
        </div>
      </div>

      <div class="col-md-4">
        <label for="#">{{$lang.Documents.LabelChecklist}}:</label>
        <div class="input-group">
          <b-form-select v-model="form.gedChecklistID.value"
                         :options="form.gedChecklistID.options"
                         :state="form.gedChecklistID.state"
                         :disabled="false"
                         class="mb-3"
                         name="cbxGedChecklist">
            <template slot="first">
              <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
            </template>
          </b-form-select>
        </div>
      </div>

      <div class="form-group col-md-12 mb-3">
        <label for="txtTag">{{$lang.Documents.LabelTags}}:</label>
        <tags-input name="txtTag"
                    :placeholder="$lang.Documents.Folder.PlaceholderTags"
                    v-model="selectedTags"
                    :existing-tags="form.gedTagID.options"
                    :typeahead="true"
                    :typeaheadHideDiscard="true"
                    id-field="value"
                    text-field="text"
                    style="font-size: 14px;" />
      </div>

      <div class="col-md-12 mb-3" v-show="hasFolderPermission(folderPermission.ADMIN, data)">
        <label for="#">{{$lang.Documents.Folder.LabelSecurity}}:</label>
        <div class="input-group">
          <b-form-radio-group id="btnPublicoPrivado"
                              class="rad-private"
                              v-model="form.seguranca.value"
                              :options="form.seguranca.options"
                              size="sm"
                              buttons />
        </div>
      </div>

      <div class="col-md-12" v-show="form.seguranca.value && hasFolderPermission(folderPermission.ADMIN, data)">
        <b-card header-tag="group-header" class="mb-1 pb-0">
          <template id="group-header">
            <h6 class="mb-0 pb-0">{{$lang.Documents.Folder.LabelGroups}}
              <b-link href="#" @click="onAddGedFolderGroup"><i class="far fa-plus-square pl-1"></i></b-link>
            </h6>
          </template>
          <b-card-body class="mb-0 pb-0" v-show="gedFolderGroups.length > 0">
            <div class="input-group align-items-center mb-1" v-for="(gedFolderGroup, index) in gedFolderGroups" :key="index">
              <b-link href="#" @click="onDeleteGedFolderGroup(index)"><i class="far fa-trash-alt text-danger mr-5"/></b-link>
              <v-select
                v-model="gedFolderGroup.grupoID"
                :options="groupOptions"
                :reduce="group => group.value"
                label="text"
                class="flex-grow-1 mr-3"
                :aria-placeholder="`-- ${$lang.Access.SelectGroup} --`">
              </v-select>
              <!-- <b-form-select v-model="gedFolderGroup.grupoID"
                             :options="groupOptions"
                             class="mr-3"/> -->
              <b-form-checkbox :checked="gedFolderGroup.Read" @change="onChangePermission('Read', gedFolderGroup)" class="ml-3 mr-3" switch>{{$lang.Documents.Folder.LabelPermissionRead}}</b-form-checkbox>
              <b-form-checkbox :checked="gedFolderGroup.Download" @change="onChangePermission('Download', gedFolderGroup)" class="ml-3 mr-3" switch>{{$lang.Documents.Folder.LabelPermissionDownload}}</b-form-checkbox>
              <b-form-checkbox :checked="gedFolderGroup.Write" @change="onChangePermission('Write', gedFolderGroup)" class="ml-3 mr-3" switch>{{$lang.Documents.Folder.LabelPermissionWrite}}</b-form-checkbox>
              <b-form-checkbox :checked="gedFolderGroup.Delete" @change="onChangePermission('Delete', gedFolderGroup)" class="ml-3 mr-3" switch>{{$lang.Documents.Folder.LabelPermissionDelete}}</b-form-checkbox>
              <b-form-checkbox :checked="gedFolderGroup.Admin" @change="onChangePermission('Admin', gedFolderGroup)" class="ml-3" switch>{{$lang.Documents.Folder.LabelPermissionAdmin}}</b-form-checkbox>
            </div>
          </b-card-body>
        </b-card>
        <b-card header-tag="user-header" class="mb-0 pb-0">
          <template id="user-header">
            <h6 class="mb-0 pb-0">{{$lang.Documents.Folder.LabelAccounts}}
              <b-link href="#" @click="onAddGedFolderAccount"><i class="far fa-plus-square pl-1"></i></b-link>
            </h6>
          </template>
          <b-card-body class="mb-0 pb-0" v-show="gedFolderAccounts.length > 0">
            <div class="input-group align-items-center mb-1" v-for="(gedFolderAccount, index) in gedFolderAccounts" :key="index">
              <b-link href="#" @click="onDeleteGedFolderAccount(index)"><i class="far fa-trash-alt text-danger mr-5"/></b-link>
              <v-select
                v-model="gedFolderAccount.contaID"
                :options="accountOptions"
                :reduce="user => user.value"
                label="text"
                class="flex-grow-1 mr-3"
                :placeholder="`-- ${$lang.Access.SelectUser} --`">
              </v-select>
              <b-form-checkbox :checked="gedFolderAccount.Read" @change="onChangePermission('Read', gedFolderAccount)" class="ml-3 mr-3" switch>{{$lang.Documents.Folder.LabelPermissionRead}}</b-form-checkbox>
              <b-form-checkbox :checked="gedFolderAccount.Download" @change="onChangePermission('Download', gedFolderAccount)" class="ml-3 mr-3" switch>{{$lang.Documents.Folder.LabelPermissionDownload}}</b-form-checkbox>
              <b-form-checkbox :checked="gedFolderAccount.Write" @change="onChangePermission('Write', gedFolderAccount)" class="ml-3 mr-3" switch>{{$lang.Documents.Folder.LabelPermissionWrite}}</b-form-checkbox>
              <b-form-checkbox :checked="gedFolderAccount.Delete" @change="onChangePermission('Delete', gedFolderAccount)" class="ml-3 mr-3" switch>{{$lang.Documents.Folder.LabelPermissionDelete}}</b-form-checkbox>
              <b-form-checkbox :checked="gedFolderAccount.Admin" @change="onChangePermission('Admin', gedFolderAccount)" class="ml-3" switch>{{$lang.Documents.Folder.LabelPermissionAdmin}}</b-form-checkbox>
            </div>
          </b-card-body>
        </b-card>
      </div>

      <div class="col-md-12 my-3" v-show="data.id && hasFolderPermission(folderPermission.ADMIN, data)">
        <b-form-checkbox id="btnPropagate"
                          v-model="form.propagar.value"
                          size="lg">
          {{$lang.Documents.Folder.LabelPropagation}}
        </b-form-checkbox>
        <br>
        <strong>{{$lang.Documents.Folder.LabelExplanationPropagation}}</strong>
      </div>

    </div>
  </Forms>
</template>

<script>
import AddFolder from './addfolder.js'
export default AddFolder
</script>

<style scoped>
* >>> .v-select {
  width: 1px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/documents/components/folder/addfolder.vue